import { Check, Clear } from '@mui/icons-material';
import { Badge, ListItem, ListItemAvatar, ListItemText, SxProps } from '@mui/material';
import React, { ReactNode } from 'react';
import Avatar from '../avatar/Avatar';
import { SimulationRole } from '../types';

export interface ClassroomStudentProps {
  avatar?: string;
  children?: ReactNode;
  joined: boolean;
  name: string;
  role: SimulationRole;
  sx?: SxProps;
}

const ClassroomStudent = ({ avatar, children, joined, name, role, sx = {} }: ClassroomStudentProps) => (
  <ListItem component="div" sx={{ height: '56px', ...sx }}>
    <ListItemAvatar>
      <Badge
        color={joined ? 'success' : 'error'}
        badgeContent={joined ? <Check sx={{ fontSize: 11 }} /> : <Clear sx={{ fontSize: 11 }} />}
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={theme => ({
          '.MuiBadge-badge': {
            border: `1px solid ${theme.palette.background.paper}`,
            p: 0,
            height: 12,
            minWidth: 12,
            zIndex: 'auto',
          },
        })}
      >
        <Avatar src={avatar} />
      </Badge>
    </ListItemAvatar>
    <ListItemText
      primary={name}
      primaryTypographyProps={{
        color: 'text.secondary',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      secondary={role === SimulationRole.Student ? '' : role}
    />
    {children}
  </ListItem>
);

export default ClassroomStudent;
